<template>
  <b-card v-if="ready" border-variant="none" :class="{ 'bg-gray': !editting }">
    <ValidationObserver ref="form">
      <b-row>
        <b-col v-if="editting" cols="12" class="mb-3">
          <span class="border rounded-circle shadow-sm p-1 mr-2">
            <i class="fas fa-edit text-orange" />
          </span>
          <span class="font-weight-bold text-gray-dark">
            {{
              item?.showChangeCapacity
                ? 'Editar Cupo de Estudiantes'
                : 'Editar Alternativa de Ubicación'
            }}
          </span>
        </b-col>
        <b-col
          v-if="item?.showChangeCapacity || !item?.id"
          cols="12"
          :md="item?.showChangeCapacity ? '4' : '12'"
          class="mb-3"
        >
          <div class="color-secondary-6 font-14">
            Límite de Cupo de Estudiantes:
          </div>
          <div class="color-black font-18">
            {{ model?.name?.studentLimit | empty }}
          </div>
        </b-col>
        <b-col v-if="!item?.showChangeCapacity" cols="12" md>
          <template v-if="editting">
            <div class="color-secondary-6 font-14">
              Categoría de Alternativa:
            </div>
            <div class="color-black font-18">
              {{ item?.category?.name | empty }}
            </div>
          </template>
          <template v-else>
            <ValidationProvider
              v-slot="{ errors }"
              rules="required"
              :custom-messages="{
                required: 'La categoria de alternativa es requerida.',
              }"
            >
              <CustomDropDown
                v-model="model.category"
                label="Categoría de Alternativa:"
                placeholder="Seleccione"
                regular-label
                fieldkey="id"
                fieldname="name"
                :options="viewmodel.categories"
                clearable
                :error="errors[0]"
                :custom-error-msg="errors[0]"
              />
            </ValidationProvider>
          </template>
        </b-col>
        <b-col v-if="!item?.showChangeCapacity" cols="12" md>
          <template v-if="editting">
            <div class="color-secondary-6 font-14">
              Nombre de Alternativa:
            </div>
            <div class="color-black font-18">
              {{ item?.name?.name | empty }}
            </div>
          </template>
          <template v-else>
            <ValidationProvider
              v-slot="{ errors }"
              rules="required"
              :custom-messages="{
                required: 'El nombre de la alternativa es requerida.',
              }"
            >
              <CustomDropDown
                v-model="model.name"
                label="Nombre de Alternativa:"
                placeholder="Seleccione"
                regular-label
                fieldkey="id"
                fieldname="name"
                :options="viewmodelByModelCriteria.names"
                clearable
                :disabled="!model.category"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
              />
            </ValidationProvider>
          </template>
        </b-col>
        <b-col v-if="!item?.showChangeCapacity" cols="12" md>
          <ValidationProvider
            v-slot="{ errors }"
            rules="required"
            :custom-messages="{
              required: 'La especialidad de salón es requerida.',
            }"
          >
            <CustomDropDown
              v-model="model.salonSpecialty"
              label="Especialidad de Salón:"
              placeholder="Seleccione"
              regular-label
              fieldkey="id"
              fieldname="title"
              :options="viewmodel.salonSpecialties"
              clearable
              :error="errors[0]"
              :custom-error-msg="errors[0]"
            />
          </ValidationProvider>
        </b-col>
        <b-col v-if="item?.showChangeCapacity || !item?.id" xs="12" md>
          <template v-if="model?.name">
            <ValidationProvider
              v-slot="{ errors }"
              :rules="studentCapacityValidations.rules"
              :custom-messages="studentCapacityValidations.messages"
            >
              <CustomInput
                type="number"
                v-model="model.studentCapacity"
                :label="
                  item?.showChangeCapacity
                    ? 'Cambio de Cupo de Estudiantes:'
                    : 'Cupo de Estudiantes'
                "
                :error="errors[0]"
                :custom-error-msg="errors[0]"
              />
            </ValidationProvider>
          </template>
          <template v-else>
            <div class="color-secondary-6 font-14">
              Cupo de Estudiantes:
            </div>
            <div class="color-black font-18">
              {{ model.name?.studentLimit | empty }}
            </div>
          </template>
        </b-col>
        <b-col v-if="item?.showChangeCapacity" md>
          <ValidationProvider
            v-slot="{ errors }"
            rules="required"
            :custom-messages="{
              required: 'La razón es requerida.',
            }"
          >
            <CustomDropDown
              v-model="model.reason"
              label="Razón:"
              placeholder="Seleccione"
              regular-label
              fieldkey="id"
              fieldname="name"
              :options="viewmodel.reasons"
              clearable
              :error="errors[0]"
              :custom-error-msg="errors[0]"
            />
          </ValidationProvider>
        </b-col>
        <b-col v-if="item?.showChangeCapacity" cols="12">
          <ValidationProvider
            v-slot="{ errors }"
            name="comment"
            rules="required"
          >
            <custom-text-area
              v-model="model.comment"
              required
              :maxlength="3000"
              label="Comentario:"
              :error="errors[0]"
              :custom-error-msg="'Campo requerido'"
              show-char-count
              :count-classes="['d-block', 'small-counter', 'text-right']"
            />
          </ValidationProvider>
        </b-col>
        <b-col v-if="!item?.showChangeCapacity" md="12" class="mt-2">
          <ValidationProvider
            v-slot="{ errors }"
            rules="required"
            :custom-messages="{ required: 'La descripción es requerida.' }"
          >
            <CustomInput
              v-model="model.description"
              label="Descripción"
              :error="errors[0]"
              :custom-error-msg="errors[0]"
            />
          </ValidationProvider>
        </b-col>
        <b-col
          v-if="(item?.showChangeCapacity || !item?.id) && !canExceedCapacity"
          cols="12"
          class="mt-2"
        >
          <warning-box
            class="mx-0"
            title="El cupo debe ser menor o igual al cupo límite computado."
          />
        </b-col>
        <b-col v-if="!item?.showChangeCapacity" cols="12" class="mt-4">
          <CustomSeparator text="GRADO" />
        </b-col>
        <b-col v-if="!item?.showChangeCapacity" cols="12" class="mt-1">
          <ValidationProvider
            v-slot="{ errors }"
            :rules="isTherapyRoomCategory ? '' : 'required'"
            :custom-messages="{
              required: 'Favor seleccionar al menos un nivel de grado.',
            }"
          >
            <b-row>
              <b-col
                v-for="grade in viewmodel.availableGrades"
                :key="grade.id"
                cols="3"
                md="2"
                class="mt-3"
              >
                <b-checkbox v-model="model.grades" :value="grade">
                  {{ grade.name }}
                </b-checkbox>
              </b-col>
            </b-row>
            <CustomError
              v-if="errors[0]"
              variant="no-border"
              :message="errors[0]"
              class="mt-1"
            />
          </ValidationProvider>
        </b-col>
        <b-col v-if="isTherapyRoomCategory" cols="12" class="mt-4">
          <CustomSeparator text="DOCUMENTOS" />
          <div class="bg-white p-3 border rounded mt-3">
            <documents
              v-model="model.documents"
              :document-types="viewmodel.documentTypes"
              :is-read-only="false"
            />
          </div>
        </b-col>
        <b-col xs="12" md="12" class="mt-4">
          <div class="d-flex flex-column flex-sm-row justify-content-end">
            <div>
              <ActionButton
                text="Cancelar"
                variant="outline-danger"
                i="fas fa-times-circle"
                class="btn-block"
                @click="cancel(true)"
              />
            </div>
            <div class="my-2 mx-2 my-sm-0" />
            <div>
              <ActionButton
                :text="'Guardar'"
                variant="success"
                :i="`fas fa-save`"
                class="btn-block"
                @click="submit"
              />
            </div>
          </div>
        </b-col>
      </b-row>
    </ValidationObserver>
  </b-card>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import CustomInputDisplay from 'CustomInputDisplay';
import CustomSeparator from 'custom-separator';
import ActionButton from 'ActionButton';
import CustomError from 'custom-error';
import alert from '@/mixin/alert.mixin';
import * as api from '@/views/pei/location-alternatives/_api';
import tapAlternativeLocationCategories from '@/utils/constants/tapAlternativeLocation/tapAlternativeLocationCategories.js';
import WarningBox from '@/components/pei/service/components/ServiceWarningBox';
import CustomTextArea from 'CustomTextArea';
import Documents from './Documents.vue';
import { Categories } from '@/utils/constants/documentTypes';

const initialModel = () => ({
  id: null,
  category: null,
  name: null,
  description: null,
  grades: [],
  active: null,
  studentCapacity: null,
  salonSpecialty: null,
  reason: null,
  comment: null,
  documents: [],
});

export default {
  name: 'LocationAlternativesAlternativeForm',
  mixins: [alert],
  components: {
    CustomDropDown,
    CustomInput,
    CustomInputDisplay,
    CustomSeparator,
    CustomError,
    ActionButton,
    WarningBox,
    CustomTextArea,
    Documents,
  },
  props: {
    item: { type: Object, default: null },
    editting: { type: Boolean, default: false },
    viewmodel: { type: Object, required: true, default: null },
  },
  data: () => ({
    model: initialModel(),
    ready: false,
  }),
  computed: {
    canSeeTherapyRoom() {
      return this.userHasPermissions(
        'academic.pei.alternativelocationcatalog.therapyroom.see'
      );
    },
    isTherapyRoomCategory() {
      return (
        this.model.category?.id === tapAlternativeLocationCategories.TherapyRoom
      );
    },
    viewmodelByModelCriteria() {
      const { category } = this.model;
      const { names } = this.viewmodel;
      return {
        names: category
          ? names.filter((x) => x.categoryId === category.id)
          : [],
      };
    },
    canExceedCapacity() {
      return this.userHasPermissions(
        'academic.pei.alternativelocationcatalog.canexceedcapacity'
      );
    },
    studentCapacityValidations() {
      const rules = ['required', 'min_value:1'];
      const messages = {
        required: 'El cupo de estudiantes es requerido.',
        min_value: 'El cupo de estudiantes debe ser mayor a 0.',
      };
      if (this.model.name?.studentLimit && !this.canExceedCapacity) {
        rules.push(`max_value:${this.model.name?.studentLimit}`);
        messages.max_value = `El cupo de estudiantes debe ser menor o igual a ${this.model.name?.studentLimit}.`;
      }
      return {
        rules: rules.join('|'),
        messages,
      };
    },
  },
  methods: {
    async submit() {
      const valid = await this.$refs['form'].validate();
      if (!valid) {
        this.ShowToast(
          'Error',
          'Favor de completar información para continuar',
          'error'
        );
        return;
      }
      if (this.model?.studentCapacity) {
        this.model.studentCapacity = Number(this.model.studentCapacity);
      }
      this.$emit('submit', this.model);
    },
    cancel(reInit = false) {
      if (reInit) {
        this.model = this.editting ? this.item : initialModel();
      }
      this.$emit('cancel');
      this.$refs['form'].reset();
    },
    async getViewmodelReasons() {
      let reasons = this.viewmodel?.reasons;
      if (!reasons?.length) {
        reasons = await api.getStudentCapacityChangeReasons();
        this.$emit('setViewModelReasons', reasons);
      }
      if (reasons?.length === 1) this.model.reason = reasons[0];
    },
    async getViewmodelCategories() {
      let categories = this.viewmodel?.categories;
      if (categories?.length) {
        if (categories.length === 1) this.model.category = categories[0];
        return;
      }
      categories = await api.getCategories();
      const values = this.canSeeTherapyRoom
        ? categories
        : categories.filter(
            (x) => x.id !== tapAlternativeLocationCategories.TherapyRoom
          );
      if (categories.length === 1) this.model.category = categories[0];

      this.$emit('setViewModelCategories', values);
    },
    async getViewmodelNames() {
      let names = this.viewmodelByModelCriteria?.names;
      if (names?.length) {
        if (names.length === 1) this.model.name = names[0];
        return;
      }
      const { category = null } = this.model;
      names = category
        ? await api.getNames({
            categoryId: category.id,
            academicYearId: this.viewmodel?.academicYearId,
          })
        : [];
      if (names.length === 1) this.model.name = names[0];
      this.$emit('setViewModelNames', names);
    },
    async getSalonSpecialties(alternativeId) {
      const salonSpecialties = await api.getSalonSpecialtiesByAlternative(
        alternativeId
      );
      if (salonSpecialties?.length === 1)
        this.model.salonSpecialty = salonSpecialties[0];
      this.$emit('setViewModelSalonSpecialties', salonSpecialties);
    },
    async getDocumentTypes() {
      const documentTypes = await api.getDocumentTypesByCategory(
        Categories.TapAlternativeLocationDocument
      );
      this.$emit('setViewModelDocumentTypes', documentTypes);
    },
    setProviderOffice() {
      this.model.description = this.model.name.name;
      this.model.grades = this.viewmodel.availableGrades;
    },
  },
  watch: {
    async 'model.category'() {
      if (!this.editting) {
        this.model.name = null;
        this.model.salonSpecialty = null;
        await this.getViewmodelNames();
      }
    },
    async 'model.name'() {
      if (!this.editting) {
        this.model.description = null;
        if (
          this.model?.name?.categoryId ===
          tapAlternativeLocationCategories.ProviderOffice
        ) {
          this.setProviderOffice();
        }
      }
      if (this.model.name) {
        await this.getSalonSpecialties(this.model.name.id);
      } else {
        this.model.salonSpecialty = null;
      }
    },
  },
  async created() {
    this.getDocumentTypes();
    if (this.editting && this.item) {
      this.model = { ...this.model, ...this.item };
      if (this.item.showChangeCapacity) {
        await this.getViewmodelReasons();
      }
    } else {
      await this.getViewmodelCategories();
    }
    this.ready = true;
  },
};
</script>
